import styled from '@emotion/styled';

import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { ImageBase } from '../common/ImageBase';

import lockedSrc from './images/indicator/door-locked.svg';
import unlockedSrc from './images/indicator/door-unlocked.svg';

export function IndicatorLock({ device }) {
  const [value, , capabilityObj] = useCapabilityValue({
    deviceId: device.id,
    capabilityId: 'locked',
  });

  return capabilityObj != null && <Container url={value ? lockedSrc : unlockedSrc} />;
}

const Container = styled(ImageBase)`
  width: auto;
  height: 24px;
`;
